export default "__VITE_ASSET__CmNO5feP__"